import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const DeadsDayFrame: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" justifyContent="center" style={{ gap: 5 }}>
                ꧁ <big>🌼</big> <small>🌼</small> <big>🪦</big>
                <small>💀</small> <big>🪦</big> <small>🌼</small>
                <big>🌼</big> ꧂
            </Box>

            <Box mb={2} mt={2}>
                {children}
            </Box>

            <Box display="flex" justifyContent="center">
                <Typography
                    variant="body2"
                    align="center"
                    style={{ color: '#666666' }}
                >
                    {t('Messages.DeadsDay')}
                </Typography>
            </Box>

            <Box
                display="flex"
                justifyContent="center"
                mt={2}
                style={{ gap: 15 }}
            >
                <span>💐</span>
                <small>🪦</small>
                <big>🪦</big>
                <small>🪦</small>
                <big>🪦</big>
                <small>🪦</small>
                <span>💐</span>
            </Box>
        </Box>
    );
};
